module.exports = __webpack_public_path__ + "static/media/instagramBlack.9a3de949.png";